div.guide-indents {
	left: var(--padding-left);
	bottom: auto;
	right: auto;
}

.guide-indents div {
	width: 1px;
	position: absolute;
	background: var(--pce-guide-indent);
}
